import { useEffect } from "react"
import { useBeUserData } from "@/common/queries/use-user"

import { useSessionInvoiceStore } from "@/store/session-invoice"
import { clearUserPartnerInvoices } from "@/utils/partner-invoice-storage"
import { clearUserSessionInvoices } from "@/utils/session-invoice-storage"

const CURRENT_USER_ID_KEY = "be_current_user_id"

/**
 * Cleans up cached invoices when the authenticated user changes or logs out.
 */
export const usePartnerInvoiceCleanup = () => {
  const userId = useBeUserData((state) => state?.data?.user_id)
  const isAuthenticated = useBeUserData((state) => !!state?.data?.user_id)

  useEffect(() => {
    const previousUserId = localStorage.getItem(CURRENT_USER_ID_KEY)

    if (isAuthenticated && userId) {
      if (previousUserId && Number.parseInt(previousUserId, 10) !== userId) {
        const previousId = Number.parseInt(previousUserId, 10)
        clearUserPartnerInvoices(previousId)
        clearUserSessionInvoices(previousId)
      }

      localStorage.setItem(CURRENT_USER_ID_KEY, userId.toString())
      return
    }

    if (!isAuthenticated && previousUserId) {
      const previousId = Number.parseInt(previousUserId, 10)
      clearUserPartnerInvoices(previousId)
      clearUserSessionInvoices(previousId)
      useSessionInvoiceStore.getState().clearSessionInvoice()
      localStorage.removeItem(CURRENT_USER_ID_KEY)
    }
  }, [userId, isAuthenticated])
}

function PartnerInvoiceCleanup() {
  usePartnerInvoiceCleanup()
  return null
}

export { PartnerInvoiceCleanup }
